import "../assets/Css/Team.css";
import React from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import profile1 from "../assets/images/pro1.png";
import profile2 from "../assets/images/pro2.png";
import profile3 from "../assets/images/pro3.png";
import adobe_after from "../assets/images/adobe-premiere-pro-icon.svg";
import after_effect from "../assets/images/after-effect.svg";
import s1 from "../assets/images/s1.svg";
import s9 from "../assets/images/s2.svg";
import s2 from "../assets/images/s3.svg";
import s3 from "../assets/images/s4.svg";
import s4 from "../assets/images/s5.svg";
import s5 from "../assets/images/s6.svg";
import s6 from "../assets/images/s7.svg";
import s7 from "../assets/images/s8.svg";
import s8 from "../assets/images/s9.svg";
import s10 from "../assets/images/s10.svg";


gsap.registerPlugin(ScrollTrigger);
const Team = () => {
  // ---------- gsap context
  React.useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // ---------- selecting all horizontal sections
      const horizontalSections = gsap.utils.toArray(".horizontal-section");

      // ---------- applying horizontal scroll animation
      gsap.to(horizontalSections, {
        xPercent: -100 * (horizontalSections.length - 1),
        ease: "none",
        scrollTrigger: {
          trigger: "#container",
          pin: true,
          scrub: 1,
          snap: 1 / (horizontalSections.length - 1),
          end: () => "+=" + document.querySelector("#container").offsetWidth,
        },
      });
    });

    return () => ctx.revert();
  }, []);
  return (
    <>
      <main id="container">
        {/* ---------- section 01 ---------- */}
        <section className="horizontal-section">
          <h1 className="heading">Team.</h1>
        </section>

        {/* ---------- section 02 ---------- */}
        <section className="horizontal-section profile-section ">
          <div className="profile-wraaper">
            <div className="profile-pic">
              <img src={profile1} alt="" />
            </div>
            <div className="profile-content">
              <div className="Profile-name"><h1>Aniket.</h1></div>
              <div className="profile-level"><h4>Video Editor, Animation</h4></div>
              <div className="profile-about"><p>I am Aniket, a video editor and animation enthusiast who has been in the game for three years. My journey revolves around bringing stories to life via the lens of creativity and technical brilliance.</p></div>
            <div className="profile-skills">
                <img src={adobe_after} alt="" />
                <img src={after_effect} alt="" />
                <img src={s10} alt="" />
              <div className="skills-title">
              </div>
            </div>
            </div>
          </div>
        </section>

        {/* ---------- section 02 ---------- */}
        <section className="horizontal-section profile-section">
        <div className="profile-wraaper">
            <div className="profile-pic">
              <img src={profile3} alt="" />
            </div>
            <div className="profile-content">
              <div className="Profile-name"><h1>Manish.</h1></div>
              <div className="profile-level"><h4>Digital Marketing, Seo</h4></div>
              <div className="profile-about"><p>Our typography obsessive design lead lives for well thought out design systems, single-origin coffee and his two very lovely children. He has 23 years experience working worldwide for clients, designing and implementing complex websites at scale, and is proud to now call Cincinnati his home.</p></div>
            <div className="profile-skills">
                <img src={adobe_after} alt="" />
                <img src={after_effect} alt="" />
              <div className="skills-title">
              </div>
            </div>
            </div>
          </div>
        </section>

        {/* ---------- section 03 ---------- */}
        <section className="horizontal-section profile-section">
        <div className="profile-wraaper">
            <div className="profile-pic">
              <img src={profile2} alt="" />
            </div>
            <div className="profile-content">
              <div className="Profile-name"><h1>Jasminder.</h1></div>
              <div className="profile-level"><h4>Web Developer</h4></div>
              <div className="profile-about"><p>Our typography obsessive design lead lives for well thought out design systems, single-origin coffee and his two very lovely children. He has 23 years experience working worldwide for clients, designing and implementing complex websites at scale, and is proud to now call Cincinnati his home.</p></div>
            <div className="profile-skills">
                <img src={s1} alt="" />
                <img src={s4} alt="" />
                <img src={s6} alt="" />
                <img src={s7} alt="" />
                <img src={s8} alt="" />
      
              <div className="skills-title">
              </div>
            </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Team;
